/*
    TODO:
    - Do not cache or attempt to guess the state of the network.
    - Dispatch the request, listen for failures, and diagnose what happened.
    - Transient errors will happen; plan for them, and use a retry strategy.
    - Listen to connection state to anticipate the best request strategy.
    - Use a backoff algorithm for request retries; do not spin forever.
    - If offline, log and dispatch the request later if possible.
    - Leverage HTML5 AppCache and localStorage for offline mode.
*/
import { InternalMessageBusChannels } from "sb-internal-msg-bus";
import { ConfigStore, STR_ERRORS, storeToken, execFunction } from "../Common";
import { ConnectionsFactory } from "./ConnectionsFactory";
import { ConnectWithToken } from "./ConnectWithToken";
import { onTokenRenew } from "./OnTokenRenew";
import { getToken } from "./Auth";
// TODO: mock E2E execution including updates
export function init(config) {
    if (typeof config.msgBus !== "object" || typeof config.msgBus.on !== "function") {
        throw new Error(STR_ERRORS.NoMessageBus);
    }
    ConfigStore.config = Object.assign(Object.assign({}, ConfigStore.config), config);
    if (Object.keys(ConfigStore.config.urls).length === 0) {
        throw new Error(STR_ERRORS.NoConnectionUrls);
    }
    // TODO: pass url for connection once we have the token
    // TODO: define no token flow... we can't connect - so? => throw
    ConfigStore.config.msgBus.on(InternalMessageBusChannels.legacy.platformJWTChange.renewJWTToken, onTokenRenew);
    const connectionNames = Object.keys(ConfigStore.config.urls);
    if (!ConfigStore.config.connections.jwt) {
        getToken().then((token) => {
            storeToken(token);
            connectionNames.forEach(x => execFunction(ConnectWithToken[x], token));
        }).catch(console.error);
    }
    connectionNames.forEach(x => ConnectionsFactory[x](ConfigStore.config.urls[x]));
}
//# sourceMappingURL=App.js.map